import React from "react";
import { Col } from "react-bootstrap";
import { UpperRow } from "../../../library/upper-row";
import TabSelector from "../../../library/tab-selector";
import GeneralContainer from "./general-container";
import PasswordContainer from "./password-container";
import LoginHistoryContainer from "./login-history-container";
import "./style.scss";

const Index = () => {
  const selectionTabs = [
    {
      key: "general",
      title: "Generelt",
      content: <GeneralContainer />,
    },
    {
      key: "password",
      title: "Passord",
      content: <PasswordContainer />,
    },
    {
      key: "logins",
      title: "Påloggingshistorikk",
      content: <LoginHistoryContainer />,
    },
  ];

  return (
    <Col md={8} className="dashboard-account-right-container">
      <Col className="inner-dashboard-account-right-container">
        <UpperRow title="Innstillinger" />
        <TabSelector defaultValue="general" items={selectionTabs} />
      </Col>
    </Col>
  );
};

export default Index;
